// Specialization for the reverse_image pipeline showing per-engine chips.

import { clsx } from "clsx";
import { PipelineCard } from "./PipelineCard";
import type { CardState } from "../state/store";

const ENGINES = ["Yandex", "Lens", "Bing"] as const;

export function ReverseImageCard({ state }: { state: CardState }) {
  return (
    <PipelineCard pipeline="reverse_image" state={state}>
      <div className="flex gap-1">
        {ENGINES.map((e) => (
          <span
            key={e}
            className={clsx(
              "rounded border border-white/10 px-1.5 py-0.5 text-[10px]",
              state.status === "complete"
                ? "text-fg"
                : "text-fg-muted",
            )}
          >
            {e}
          </span>
        ))}
      </div>
    </PipelineCard>
  );
}
